import React from "react";
import { FormSectionElements, ProgramContainer } from "../../entities/formTemplateDataType";
import PasswordShow from '../../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-password-show.svg'
import { getRootComponent } from "../../utilities/ElementUtils";

interface Props {
    field: FormSectionElements;
    callback: (programContainer: ProgramContainer) => void
}

export default class PasswordShowButtonCompnent extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

    }

    render() {
        const field = this.props.field;
        return <button type="button" aria-pressed="false" aria-label="Show field" aria-live="polite" style={{ border: 'none', backgroundColor: 'transparent', padding: 0, cursor: 'pointer' }} onClick={() => { field.mask = false; this.props.callback(getRootComponent(field)) }}>
            <img
                src={PasswordShow}
                alt="Field is hidden"
                style={{
                    cursor: 'pointer',
                    height: '24px',
                    width: '24px'
                }}>
            </img>
        </button>
    }
}